export default __webpack_public_path__ + "static/media/activityIcon.8c560565.svg";